import { Divider } from "@mui/material";
import PlusIcon from "../../common/images/Plus_Active.svg";
import MinusIcon from "../../common/images/Minus_Active.svg";

let childAgeOptions = [];
for (let index = 2; index <= 12; index++) {
  childAgeOptions.push({ label: index, value: index });
}
const PassengerSelection = (props) => {
  const { state, setState, onClose } = props;

  const onChangeChildAge = (childIndex, direction) => {
    setState((prev) => {
      console.log(prev);
      const currentList = [...prev.childAgeList];

      // Get current index from childAgeOptions (assuming you store the full value object)
      const currentValue = currentList[childIndex];
      let currentOptionIndex = childAgeOptions.findIndex(
        (option) => option.value === currentValue?.value
      );

      // If not found, assume starting at 0
      if (currentOptionIndex === -1) currentOptionIndex = 0;
      // console.log("currentOptionIndex", currentOptionIndex, currentOptionIndex);

      // Compute new index
      let newIndex =
        direction === "inc"
          ? Math.min(
              childAgeOptions.length - 1,
              Object.keys(currentList[childIndex])?.length === 0
                ? currentOptionIndex
                : currentOptionIndex + 1
            )
          : Math.max(0, currentOptionIndex - 1);

      currentList[childIndex] = childAgeOptions[newIndex];

      return { ...prev, childAgeList: currentList };
    });
  };

  const applyQty = (member, qtystatus, ageIndex) => {
    setState((prevState) => {
      let { room_count, adults, child, childAgeList } = prevState;

      // Clone array to avoid direct state mutation
      let updatedChildAges = [...childAgeList];

      // === Handle increment ===
      if (qtystatus === "P") {
        if (member === "adults") {
          if (adults < room_count * 2) {
            adults += 1;
          } else if (room_count < 10) {
            // Need new room
            room_count += 1;
            adults += 1;
          }
        } else if (member === "children") {
          if (child < room_count * 2) {
            child += 1;
            updatedChildAges.push(2);
          } else if (room_count < 10) {
            room_count += 1;
            child += 1;
            adults += 1; // Ensure every room has an adult
            updatedChildAges.push(2);
          }
        } else if (member === "room_count") {
          if (room_count < 10) {
            room_count += 1;
            if (adults < room_count) {
              adults += 1;
            }
          }
        } else if (member === "childAges") {
          const age = updatedChildAges[ageIndex] || 2;
          if (age < 17) {
            updatedChildAges[ageIndex] = age + 1;
          }
        }
      }

      // === Handle decrement ===
      if (qtystatus === "M") {
        if (member === "adults" && adults > 1) {
          adults -= 1;
          if (room_count > adults) {
            room_count = adults;
          }
        } else if (member === "children" && child > 0) {
          child -= 1;
          updatedChildAges.pop();
        } else if (member === "room_count" && room_count > 1) {
          room_count -= 1;
        } else if (member === "childAges") {
          const age = updatedChildAges[ageIndex] || 2;
          if (age > 2) {
            updatedChildAges[ageIndex] = age - 1;
          }
        }
      }

      const rooms = generateRoomStructureByRoomCount({
        room_count,
        adults,
        child,
        childAgeList: updatedChildAges,
      });

      return {
        ...prevState,
        room_count,
        adults,
        child,
        childAgeList: updatedChildAges,
        rooms,
      };
    });
  };

  const generateRoomStructureByRoomCount = ({
    room_count,
    adults,
    child,
    childAgeList,
  }) => {
    const rooms = Array.from({ length: room_count }, () => ({
      adult: 0,
      child: [],
    }));

    if (adults < room_count) {
      throw new Error("Not enough adults to assign at least one per room.");
    }

    let adultIndex = 0;
    let childIndex = 0;

    // Step 1: Assign 1 adult to each room
    for (let i = 0; i < room_count; i++) {
      rooms[i].adult = 1;
      adultIndex++;
    }

    // Step 2: Distribute remaining adults
    let remainingAdults = adults - room_count;
    for (let i = 0; i < room_count && remainingAdults > 0; i++) {
      const totalPeople = rooms[i].adult + rooms[i].child.length;
      if (rooms[i].adult < 2 && totalPeople < 4) {
        rooms[i].adult += 1;
        remainingAdults--;
      }
    }

    // Step 3: Distribute children with ages
    for (let i = 0; i < child; i++) {
      let placed = false;
      for (let j = 0; j < room_count; j++) {
        const room = rooms[j];
        const totalPeople = room.adult + room.child.length;
        if (room.child.length < 2 && totalPeople < 4) {
          room.child.push(childAgeList[childIndex] ?? 2);
          childIndex++;
          placed = true;
          break;
        }
      }

      if (!placed) {
        console.warn("Cannot place child: all rooms full.");
        break;
      }
    }

    return rooms;
  };

  // console.log(state);
  return (
    <div className="add-room-list">
      <ul>
        <li>
          <div className="addcart_row">
            <label className="sel-quality">
              Rooms
              <span className="price-select">Max-8</span>
            </label>
            <div className="qty-box">
              <span
                className="qty-minus"
                onClick={() => applyQty("room_count", "M")}
              >
                <img className="minus-ic" src={MinusIcon} alt="Minus" />
              </span>
              <input
                type="text"
                className="qty-input"
                readOnly={true}
                value={state.room_count}
              />
              <span
                className="qty-plus"
                onClick={() => applyQty("room_count", "P")}
              >
                <img className="plus-ic" src={PlusIcon} alt="Plus" />
              </span>
            </div>
          </div>
        </li>
        <Divider />
        <li>
          <div className="addcart_row">
            <label className="sel-quality">
              Adult
              <span className="price-select">Age 13 or above</span>
            </label>
            <div className="qty-box">
              <span
                className="qty-minus"
                onClick={() => applyQty("adults", "M")}
              >
                <img className="minus-ic" src={MinusIcon} alt="Minus" />
              </span>
              <input
                type="text"
                className="qty-input"
                readOnly={true}
                value={state.adults}
              />
              <span
                className="qty-plus"
                onClick={() => applyQty("adults", "P")}
              >
                <img className="plus-ic" src={PlusIcon} alt="Plus" />
              </span>
            </div>
          </div>
        </li>
        <li className={state.adults === 0 ? "disable" : ""}>
          <div className="addcart_row">
            <label className="sel-quality">
              Children
              <span className="price-select">Age 2 to 12</span>
            </label>
            <div className="qty-box">
              <span
                className="qty-minus"
                onClick={() => applyQty("children", "M")}
              >
                <img className="minus-ic" src={MinusIcon} alt="Minus" />
              </span>
              <input
                type="text"
                className="qty-input"
                readOnly={true}
                value={state.child}
              />
              <span
                className="qty-plus"
                onClick={() => applyQty("children", "P")}
              >
                <img className="plus-ic" src={PlusIcon} alt="Plus" />
              </span>
            </div>
          </div>
        </li>
        {state.child > 0 && (
          <>
            {(() => {
              const options = [];
              for (let i = 0; i < state.child; i++) {
                let j = 0;
                options.push(
                  <li
                    className={`child-age ${
                      state.adults === 0 ? "disable" : ""
                    }`}
                  >
                    <div className="addcart_row">
                      <label className="sel-quality">
                        Select age for child {parseInt(i) + 1}{" "}
                      </label>
                      <div className="qty-box">
                        <span
                          className="qty-minus"
                          onClick={() => {
                            applyQty("childAges", "M", i);
                          }}
                        >
                          <img
                            className="minus-ic"
                            src={MinusIcon}
                            alt="Minus"
                          />
                        </span>
                        <input
                          type="text"
                          className="qty-input"
                          readOnly={true}
                          value={
                            state.childAgeList?.length > 0 &&
                            state.childAgeList[i]
                              ? state.childAgeList[i]
                              : 2
                          }
                        />
                        <span
                          className="qty-plus"
                          onClick={() => {
                            applyQty("childAges", "P", i);
                          }}
                        >
                          <img className="plus-ic" src={PlusIcon} alt="Plus" />
                        </span>
                      </div>
                    </div>
                  </li>
                );
              }
              return options;
            })()}
          </>
        )}
      </ul>

      <button type="submit" className="button" onClick={() => onClose()}>
        Done
      </button>
    </div>
  );
};

export default PassengerSelection;
